export default __webpack_public_path__ + "static/media/3.28.4eb07687.mp3";